import Vue from "vue";
import VueI18n from "vue-i18n";

import buttonsModule from "./modules/buttons";
import headersModule from "./modules/headers";
import descriptionsModule from "./modules/descriptions";
import usersModule from "./modules/users";
import solicitationsModule from "./modules/solicitations";
import proceduresModule from "./modules/procedures";
import patientsModule from "./modules/patients";
import profilesModule from "./modules/profiles";
import unitiesModule from "./modules/unities";
import passwordModule from "./modules/password";
import salutationsModule from "./modules/salutations";
import inputsModule from "./modules/inputs";
import placeholdersModule from "./modules/placeholders";
import helpersModule from "./modules/helpers";
import menuModule from "./modules/menu";
import statusModule from "./modules/status";
import modalsModule from "./modules/modals";
import messagesModule from "./modules/messages";
import documentModule from "./modules/documents";
import professionalsModule from "./modules/professionals";
import schedulesModule from "./modules/schedules";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "pt",
  messages: {
    pt: {
      system_abbreviation: "SRA",
      system_name: "Sistema de Regulação Ambulatorial",
      desenv_version: "Versão 2.13.2 D2904H1147",
      prod_version: "Versão 2.6.0 D1505H0930",

      descriptions: descriptionsModule,
      headers: headersModule,
      users: usersModule,
      solicitations: solicitationsModule,
      procedures: proceduresModule,
      patients: patientsModule,
      profiles: profilesModule,
      unities: unitiesModule,
      password: passwordModule,
      salutations: salutationsModule,
      buttons: buttonsModule,
      inputs: inputsModule,
      placeholders: placeholdersModule,
      helpers: helpersModule,
      menu: menuModule,
      status: statusModule,
      modals: modalsModule,
      messages: messagesModule,
      documents: documentModule,
      professionals: professionalsModule,
      schedules: schedulesModule,
    },
  },
});

export default i18n;
